import React from 'react';
import styled, { css } from 'styled-components';

const CarouselArrowImg = styled.svg<{ $flip?: boolean }>`
  display: block;
  width: 16px;
  height: 16px;

  ${({ $flip }) =>
    $flip &&
    css`
      transform: scaleX(-1);
    `}
`;

const TitleUnderlineSvg = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
`;

export const TitleUnderline: React.FC = () => (
  <TitleUnderlineSvg
    viewBox="0 0 130 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1.63892 4.40929C1.79109 4.40929 1.94326 4.40929 11.0759 4.32489C20.2086 4.2405 38.3172 4.0717 50.385 3.77376C62.4528 3.47581 67.931 3.05383 80.9487 2.58326C93.9664 2.11268 114.358 1.60631 122.884 1.64083C131.41 1.67536 127.454 2.26613 119.024 3.16125C110.595 4.05636 97.8122 5.23791 86.7382 6.60616C75.6642 7.9744 66.686 9.49354 61.7565 10.3605C55.1346 11.739 50.2513 13.0944 46.8366 14.0829C46.3732 14.2121 45.9166 14.2965 44.524 14.6392"
      stroke="#EB6424"
      strokeLinecap="round"
      strokeWidth="3.27791"
    />
  </TitleUnderlineSvg>
);

export const QuoteIcon: React.FC = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8533 9.11599C11.3227 13.9523 7.13913 19.5812 6.30256 26.0029C5.00021 36 13.9404 40.8933 18.4703 36.4967C23.0002 32.1002 20.2848 26.5196 17.0047 24.9942C13.7246 23.4687 11.7187 24 12.0686 21.9616C12.4185 19.9231 17.0851 14.2713 21.1849 11.6392C21.4569 11.4079 21.5604 10.9591 21.2985 10.6187C21.1262 10.3947 20.7883 9.95557 20.2848 9.30114C19.8445 8.72888 19.4227 8.75029 18.8533 9.11599Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.6789 9.11599C31.1484 13.9523 26.9648 19.5812 26.1282 26.0029C24.8259 36 33.7661 40.8933 38.296 36.4967C42.8259 32.1002 40.1105 26.5196 36.8304 24.9942C33.5503 23.4687 31.5443 24 31.8943 21.9616C32.2442 19.9231 36.9108 14.2713 41.0106 11.6392C41.2826 11.4079 41.3861 10.9591 41.1241 10.6187C40.9519 10.3947 40.614 9.95557 40.1105 9.30114C39.6702 8.72888 39.2484 8.75029 38.6789 9.11599Z"
      fill="currentColor"
    />
  </svg>
);

export const VerifiedIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
      fill="currentColor"
    />
  </svg>
);

export const CarouselArrowPrev: React.FC = () => (
  <CarouselArrowImg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M4.293 7.294a1 1 0 0 0 0 1.414l5.185 5.186a1 1 0 0 0 1.415-1.415L6.414 8.002l4.479-4.478a1 1 0 0 0-1.415-1.414L4.293 7.294Z"
      fill="#383838"
    />
  </CarouselArrowImg>
);

export const CarouselArrowNext: React.FC = () => (
  <CarouselArrowImg
    $flip
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M4.293 7.294a1 1 0 0 0 0 1.414l5.185 5.186a1 1 0 0 0 1.415-1.415L6.414 8.002l4.479-4.478a1 1 0 0 0-1.415-1.414L4.293 7.294Z"
      fill="#383838"
    />
  </CarouselArrowImg>
);
